import React, { useEffect } from 'react';
import styled from 'styled-components';

import { LeftNavbar } from '../../components/Navbars';
import { InfoOutlined } from '@mui/icons-material';
import { Stack, alpha } from '@mui/material';
import { Tooltip } from '..';

const Container = styled.div`
  min-height: 100vh;
  max-height: 100vh;

  align-items: stretch;
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 0;
`;

const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;

  flex: 1 1 auto;
  min-width: 0;
  padding-left: 60px;
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => alpha(theme.text.standard, 0.5)};

  &:hover {
    cursor: pointer;

    svg {
      color: ${({ theme }) => theme.text.standard};
    }
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 28px;
  min-height: 70px;
  max-height: 70px;

  color: ${({ theme }) => theme.text.standard};
`;

const Body = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  min-height: 0;
  align-items: stretch;
`;

interface Props {
  header?: string;
  view?: React.ReactNode;
  actions?: React.ReactNode;
  body: React.ReactNode;
  tooltip?: string;
}

export const LayoutBase: React.FC<Props> = ({ header, view, actions, body, tooltip }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [header]);

  return (
    <Container>
      <LeftNavbar />
      <Wrapper>
        {header && (
          <Header>
            <Stack direction='row' spacing={2}>
              <Stack direction='row' spacing={1} alignItems='center'>
                <h3>{header}</h3>
                {tooltip && (
                  <Tooltip sx={{ maxWidth: '600px' }} title={tooltip} placement='right'>
                    <Info>
                      <InfoOutlined sx={{ fontSize: '2ch' }} />
                    </Info>
                  </Tooltip>
                )}
              </Stack>
              <div>{view}</div>
            </Stack>
            {actions}
          </Header>
        )}
        <Body>{body}</Body>
      </Wrapper>
    </Container>
  );
};
